module.exports = __webpack_public_path__ + "img/NDMedicalplus.626d4a1c.png";